import React from 'react';
import { Link } from 'react-router-dom';
import { Hidden } from '@material-ui/core';

/**
 * 내 강의실 바로가기 모바일 버튼
 * - 메인 페이지의 배너 슬라이드와 추천강의 섹션 사이에 배치
 * - 모바일(sm 이하)에서만 노출
 * - 로그인 상태: /learning으로 이동
 * - 비로그인 상태: /login으로 이동
 */
const MobileMyClassButton = () => {
  const loginToken = localStorage.getItem('token');

  return (
    <Hidden mdUp>
      <div style={{ padding: '20px 20px' }}>
        <Link
          to={loginToken ? '/learning' : '/login'}
          style={{
            display: 'block',
            background: 'linear-gradient(to bottom, #fe7a36, #fc571b)',
            borderRadius: '12px',
            width: '100%',
            height: '50px',
            lineHeight: '50px',
            textAlign: 'center',
            color: 'white',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '21px',
            boxShadow: '1px 2px 4px rgba(0, 0, 0, 0.4)',
          }}
        >
          내 강의실 바로가기 &gt;
        </Link>
      </div>
    </Hidden>
  );
};

export default MobileMyClassButton;
